var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"micro-web"})
}
var staticRenderFns = []

export { render, staticRenderFns }